


















































































import mixins from 'vue-typed-mixins';
import { PaymentMethod, PaymentProcessor, PaymentSource } from '@/Payment/Enums';
import { ProcessorVariables } from '@/Payment/ProcessorVariables';
import CreditCardPayment from './CreditCardPayment.vue';
import PaymentMethodMixin from './PaymentMethodMixin';
import HostedCheckoutPayment from './HostedCheckoutPayment.vue';
import CheckPayment from './CheckPayment.vue';
import VatsAPI from '@/Shared/VatsAPI';
import MoneyOrderPayment from './MoneyOrderPayment.vue';
import GenericPayment from './GenericPayment.vue';
import Five9Payment from '@/Payment/PaymentMethods/HostedPaymentTypes/Five9/Five9Payment.vue';

const component = mixins(PaymentMethodMixin).extend({
    components: {
        // card
        HostedCheckoutPayment,
        CreditCardPayment,
        // check
        CheckPayment,
        // money order
        MoneyOrderPayment,
        // cash, other
        GenericPayment,
        Five9Payment
    },
    computed: {
        methodName(): string {
            const methods: { [propName: string]: string } = PaymentMethod;
            for (const key in methods) {
                if (!methods[key]) {
                    continue;
                }

                if (methods[key] === this.method) {
                    return key;
                }
            }
            return '';
        },
        isCallInPayment(): boolean {
            return this.isInternal && this.source === PaymentSource.CallIn;
        },
        processorVariablesEndpoint(): string {
            return `${this.location}/Payments/ProcessorVariables`;
        },
        paymentProcessor(): PaymentProcessor | null {
            return this.processorVariables ? this.processorVariables.processor : null;
        }
    },
    async beforeMount() {
        const result = await VatsAPI.get<ProcessorVariables>(this.processorVariablesEndpoint);
        this.processorVariables = result.data;
    },
    props: {
        location: {
            required: true,
            type: String,
        }
    },
    data() {
        return {
            PaymentMethod,
            PaymentProcessor,
            processorVariables: null as ProcessorVariables | null
        };
    }
});

export default component;
